import { EquipmentDto } from './models';

export class EquipmentDtoEmpty implements EquipmentDto{
  name = '';
}